import React, {useContext, useMemo} from "react";
import {buildCssUrlString, getPlatform} from "../../../../utils/StringUtilities";
import {createRef} from "react";
import SocialMarkdown, {traverseAndShorten} from "../../../utilities/SocialMarkdown";
import moment from "moment";
import styles from "./styles/NewsItem.module.scss"
import FontAwesome from "../../../utilities/FontAwesome";
import {modalStore, StoreContext} from "../../../../stores/StoreLoader";
import {observer} from "mobx-react";
import {EditButton} from "../EditButton";
import {getAltText} from "../../../../stores/SchoolFeedStore";
import {handleContentItemClick} from "../../SchoolBlocks/ContentItemBlock/ContentItemBlock";

interface Props {
    itemObj: NewsContentItem;
    isTop: boolean;
    handleSave: (contentItem: ContentItem, organization: BaseOrganization) => void,
    handleDelete: (contentItem: ContentItem) => void,
}

export function ContentItemDate(props: {
    contentItem: ContentItem,
}) {
    const date = moment(props.contentItem.created_at).format('MMM D, YYYY');
    return <div className={styles.contentItemDate}>
        <div className={styles.date}>
            {`Posted: ${date}`}
        </div>
    </div>
}

const NewsItem: React.FC<Props> = observer((props) => {
    const {interfaceStore} = useContext(StoreContext);
    const attribution = getPlatform(props.itemObj.type);
    const descriptionRef: React.RefObject<any> = createRef();

    const {shortenLengthDescription, shortenLengthTitle} = useMemo(() => {
        let shortenLengthDescription = 120, shortenLengthTitle = 20;

        if (descriptionRef.current?.clientHeight > 210) {
            shortenLengthDescription = 20;
        }
        if (interfaceStore.width < 1280) {
            shortenLengthDescription = 85;
        }
        if (interfaceStore.width < 1280 && interfaceStore.width > 620) {
            shortenLengthTitle = 14;
        }

        return {shortenLengthDescription, shortenLengthTitle};
    }, [interfaceStore.width])

    let link;

    let itemDescription = props.itemObj.description;
    if (props.itemObj.description.length && props.itemObj.description.length > shortenLengthDescription) { // build description - switch for attribution
        itemDescription = traverseAndShorten(itemDescription, shortenLengthDescription)
        link = <span className={styles.button}>Read More</span>
    }

    const description = itemDescription ?
        <SocialMarkdown platform={attribution} text={itemDescription}/> : "";

    let descriptionStyle = {};
    if (!props.itemObj.title) {
        descriptionStyle = {
            fontSize: 'calc(15px + 0.5vw)',
        }
    }

    let itemTitle = props.itemObj.title;
    if (itemTitle && itemTitle.length > shortenLengthTitle) {
        itemTitle = traverseAndShorten(itemTitle, shortenLengthTitle)
        link = <span className={styles.button}>Read More</span>
    }

    let imageStyle = {};
    let withImage = {};

    if (props.isTop) {
        if (props.itemObj.json_data?.news?.cover_image_url) {

            imageStyle = {
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                width: '30%',
                height: '100%',
                backgroundImage: buildCssUrlString(props.itemObj.json_data.news.cover_image_url),
                backgroundRepeat: 'no-repeat',
                backgroundPosition: "50% 50%",
                backgroundSize: 'cover',
                borderRadius: '10px 0px 0px 10px',
            };

            withImage = {
                width: '70%',
            }
        }
    }

    return (
        <div className={styles.innerBoundsContainer} onClick={() => handleContentItemClick(props.itemObj)} onKeyPress={e => {
            if (e.key === "Enter") handleContentItemClick(props.itemObj);
        }} tabIndex={0}>
            <div style={imageStyle} role={"img"} aria-label={getAltText(props.itemObj)}/>
            <div className={styles.contentContainer} style={withImage}>
                {itemTitle && <div className={styles.titleContainer}>
                    <h2>{itemTitle}</h2>
                </div>}
                <div className={styles.dateContainer}>
                    <ContentItemDate contentItem={props.itemObj} />
                </div>
                <div className={styles.descriptionContainer} ref={descriptionRef} style={descriptionStyle}>
                    {description}
                </div>
                <div className={styles.bottomText}>
                    {link && <div className={styles.link}>
                        {link}
                    </div>}
                    {props.itemObj.organization && <div className={styles.organizationTitle}>
                        {props.itemObj.organization.title}
                    </div>}
                </div>
                <EditButton
                    handleDelete={props.handleDelete}
                    handleSave={props.handleSave}
                    contentItem={props.itemObj}
                />
            </div>
        </div>
    );
})

export default NewsItem;
